import { ImageMessage } from '@lowcodeunit/lcu-file-uploader-common';

export class UserPhoto{
    public ID?: any;
    public LocationID: any;
    public URL: string;
    public Caption?: string;
    public Image: ImageMessage;
    
    
    constructor(locationid: any, url: string, image: ImageMessage, caption?: string, ID?: any ){
        this.LocationID = locationid;
        this.URL = url;
        this.Caption = caption;
        this.ID = ID;
        this.Image = image;
    }
}